import Cara from '@lekoarts/gatsby-theme-cara/src/templates/cara'

export default Cara;